import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicBaseAnalytics } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getBaseAnalytics = async (
  organisationId?: string,
): Promise<PublicBaseAnalytics> => {
  const response = await axiosClient.get(`/analytics/base`, {
    params: { ...(organisationId && { organisationId }) },
  });
  return response.data;
};

export function getBaseAnalyticsQueryKey(organisationId?: string) {
  return ["base-analytics", organisationId];
}

export function useGetBaseAnalytics(
  organisationId?: string,
  queryOptions?: Partial<UseQueryOptions<PublicBaseAnalytics, HttpError>>,
) {
  return useQuery({
    queryKey: getBaseAnalyticsQueryKey(organisationId),
    queryFn: () => getBaseAnalytics(organisationId),
    ...queryOptions,
  });
}
